import React, { Component } from 'react';
import _ from 'lodash';

class SingleChoice extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: []
		};
		this.handleChange = this.handleChange.bind(this);
	}
	handleValidation(value) {
		const isEmpty = _.isEqual(value, ['']) || _.isEmpty(value);
		return !isEmpty ? true : false;
	}
	handleParentStateCallback(value) {
		const { id, inputName } = this.props.fieldcollection;
		const validation = this.handleValidation(value);
		const obj = {
			id,
			inputName,
			value,
			validation
		};
		this.props.parentStateCallback(obj);
	}
	handleChange(e) {
		const inputValue = [e.target.value];
		this.setState({
			value: inputValue
		});
		this.handleParentStateCallback(inputValue);
	}
	builder({ answers, inputName, id }) {
		return _.map(answers, (answer, i) => {
			const inputId = `${id}_${answer.value}`;
			return (
				<div key={i} className="form-check">
					<input
						type="radio"
						name={inputName}
						value={answer.value}
						id={inputId}
						onChange={this.handleChange}
						className={
							_.includes(this.props.errors, id)
								? 'form-check-input is-invalid'
								: 'form-check-input'
						}
					/>
					<label htmlFor={inputId} className="form-check-label">
						{answer.label}
					</label>
				</div>
			);
		});
	}
	render() {
		const { question } = this.props.fieldcollection;
		return (
			<div className="border rounded px-4 py-3 mb-4">
				<h5>{question}</h5>
				{_.includes(this.props.errors, this.props.fieldcollection.id) && (
					<div className="alert alert-danger">Selecione un valor.</div>
				)}				
				<div>{this.builder(this.props.fieldcollection)}</div>
				<br />
				<div className="d-none">valor: {this.state.value.sort().toString()}</div>
			</div>
		);
	}
}

export default SingleChoice;



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/FieldCollection/SingleChoice.js